import { toast as shadcnToast } from '../components/ui/use-toast';

export const useToast = () => {
  const toast = ({ title, description, variant = 'default' }: { 
    title: string; 
    description?: string; 
    variant?: 'default' | 'destructive';
  }) => {
    shadcnToast({
      title,
      description,
      variant
    });
  };

  // Alias simplifié pour compatibilité
  const showToast = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') => {
    const variant = type === 'error' ? 'destructive' : 'default';
    shadcnToast({
      title: message,
      variant
    });
  };

  return { toast, showToast };
};